var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1118 9.992L19 8.392L17.3437 5.624L14.942 6.408C14.412 5.976 13.8157 5.64 13.1532 5.4L12.6563 3H9.34369L8.84679 5.384C8.18427 5.624 7.58799 5.96 7.05797 6.392L4.65631 5.608L3 8.376L4.8882 9.976C4.75569 10.776 4.75569 11.192 4.8882 11.992L3 13.592L4.65631 16.36L7.05797 15.576C7.58799 16.008 8.18427 16.344 8.84679 16.584L9.34369 19H12.6563L13.1532 16.616C13.8157 16.376 14.412 16.04 14.942 15.608L17.3437 16.392L19 13.624L17.1118 12.024C17.2443 11.208 17.2443 10.792 17.1118 9.992ZM11 14.2C9.17805 14.2 7.68737 12.76 7.68737 11C7.68737 9.24 9.17805 7.8 11 7.8C12.8219 7.8 14.3126 9.24 14.3126 11C14.3126 12.76 12.8219 14.2 11 14.2Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.99677ec976be0497db447b1065930db7.svg";
export { ForwardRef as ReactComponent };